/**
 * Legal-ownership strings — runtime side of the branding SSOT.
 *
 * Mirrors /branding.config.json; branding.test.ts fails CI if they drift.
 * PLACEHOLDER until the legal entity is formed: the owner-of-record is the
 * operating brand "AI Reading Labs". When the company exists, update
 * branding.config.json and these constants together (one commit) — see
 * docs/ip-protection-implementation-handoff.md. Never hardcode the owner
 * name at call sites; always import from here.
 */
export const LEGAL_OWNER = 'AI Reading Labs';
export const PRODUCT_NAME = 'AI Reading Labs';
export const PUBLIC_DOMAIN = 'aireadinglabs.com';
export const SUPPORT_EMAIL = `support@${PUBLIC_DOMAIN}`;
export const PRIVACY_EMAIL = `privacy@${PUBLIC_DOMAIN}`;
export const BILLING_EMAIL = `billing@${PUBLIC_DOMAIN}`;
export const COPYRIGHT_YEAR_FIRST = 2026;

/** "© 2026 AI Reading Labs. …" in the session language (EN default, FR supported). */
export function copyrightLine(locale?: string): string {
  const lang =
    locale ??
    (typeof document !== 'undefined' ? document.documentElement.lang : 'en');
  return lang.toLowerCase().startsWith('fr')
    ? `© ${COPYRIGHT_YEAR_FIRST} ${LEGAL_OWNER}. Tous droits réservés.`
    : `© ${COPYRIGHT_YEAR_FIRST} ${LEGAL_OWNER}. All rights reserved.`;
}

export const USAGE_TERMS =
  `Proprietary content of ${LEGAL_OWNER}. May not be copied, reproduced, ` +
  'distributed, or used without written permission.';
